import { appStoreUrl, playStoreUrl } from '../lib/storeLinks';

/**
 * The call-to-action block on every share landing page (SK-203).
 *
 * All three pages had hand-copied the same three anchors, which is how two of
 * them stayed broken in the same two ways for their whole life: a deep link the
 * app could not route, and store URLs that 404. One component, one place to fix.
 *
 * `deepLink` is null when the page has no id to point at (a malformed code), in
 * which case the button is omitted rather than rendered inert.
 */
export function AppCta({ deepLink }: { deepLink: string | null }) {
  const hasStoreLinks = appStoreUrl || playStoreUrl;

  return (
    <div className="skf-stack">
      {deepLink ? (
        <a className="skf-cta" href={deepLink}>
          Open in Skiffs
        </a>
      ) : null}

      {hasStoreLinks ? (
        <>
          {appStoreUrl ? (
            <a className="skf-cta skf-cta--ghost" href={appStoreUrl}>
              Get on iOS
            </a>
          ) : null}{' '}
          {playStoreUrl ? (
            <a className="skf-cta skf-cta--ghost" href={playStoreUrl}>
              Get on Android
            </a>
          ) : null}
        </>
      ) : (
        // Pre-launch. Saying nothing would leave "Open in Skiffs" looking like a
        // broken button to someone who doesn't have the app; two links to a 404
        // is worse still.
        <p className="skf-meta">Skiffs is in private beta — the apps aren&rsquo;t public yet.</p>
      )}
    </div>
  );
}
